import React, { Children } from 'react';
import styled from 'styled-components';
import _get from 'lodash/get';

import COLORS from '@mlb/react-patterns/style/universal.color';

const NoResultsMessage = styled.p.attrs(({ dictionary }) => ({
    children: _get(dictionary, 'no_results_message', 'No Results'),
}))`
  font-size: 13px;
  font-weight: 700;
  color: ${COLORS.mlbWhite};
  padding: 18px 4px 60px 0px;
  cursor: default;
  &:hover {
    background-color: transparent;
  }
`;

export default NoResultsMessage;
